import { get } from '../../infra/rest';
import { WabaInfoResponse } from '../typings';

export const getWabaInfo = (): Promise<WabaInfoResponse> => {
  return get<WabaInfoResponse>('/v1/dashboard/waba-info', {}, true);
};
